/** @typedef {string} MessagePreviewType */
export const MESSAGE_PREVIEW_TYPE_SMS = 'SMS';
export const MESSAGE_PREVIEW_TYPE_EMAIL = 'EMAIL';
export const MESSAGE_PREVIEW_TYPE_VIBER = 'VIBER';
export const MESSAGE_PREVIEW_TYPE_WHATSAPP = 'WHATSAPP';
export const MESSAGE_PREVIEW_TYPE_PUSH = 'PUSH_NOTIFICATION';
/** @enum {MessagePreviewType} */
export const MESSAGE_PREVIEW_TYPE = {
	SMS: MESSAGE_PREVIEW_TYPE_SMS,
	EMAIL: MESSAGE_PREVIEW_TYPE_EMAIL,
	VIBER: MESSAGE_PREVIEW_TYPE_VIBER,
	WHATSAPP: MESSAGE_PREVIEW_TYPE_WHATSAPP,
	PUSH: MESSAGE_PREVIEW_TYPE_PUSH,
};
/** @type {MessagePreviewType[]} */
export const MESSAGE_PREVIEW_TYPES = [
	MESSAGE_PREVIEW_TYPE_SMS,
	MESSAGE_PREVIEW_TYPE_EMAIL,
	MESSAGE_PREVIEW_TYPE_VIBER,
	MESSAGE_PREVIEW_TYPE_WHATSAPP,
	MESSAGE_PREVIEW_TYPE_PUSH,
];

/** @type {Object<MessagePreviewType, {symbol: string, [symbolPrefix]: string}>} */
export const MESSAGE_PREVIEW_TYPE_ICONS = {
	[MESSAGE_PREVIEW_TYPE_SMS]: {symbol: 'ui-messaging', symbolPrefix: 'icofont-'},
	[MESSAGE_PREVIEW_TYPE_VIBER]: {symbol: 'brand-viber', symbolPrefix: 'icofont-'},
	[MESSAGE_PREVIEW_TYPE_WHATSAPP]: {symbol: 'whatsapp', symbolPrefix: 'icofont-'},
	[MESSAGE_PREVIEW_TYPE_PUSH]: {symbol: 'notification', symbolPrefix: 'icofont-'},
	[MESSAGE_PREVIEW_TYPE_EMAIL]: {symbol: 'email', symbolPrefix: 'icofont-'},
};


/** @typedef {string} MessagePreviewButtonType */
export const MESSAGE_PREVIEW_BUTTON_TYPE_QUICK_REPLY = 'QUICK_REPLY';
export const MESSAGE_PREVIEW_BUTTON_TYPE_URL = 'URL';
export const MESSAGE_PREVIEW_BUTTON_TYPE_PHONE = 'PHONE_NUMBER';
/** @enum {MessagePreviewButtonType} */
export const MESSAGE_PREVIEW_BUTTON_TYPE = {
	QUICK_REPLY: MESSAGE_PREVIEW_BUTTON_TYPE_QUICK_REPLY,
	URL: MESSAGE_PREVIEW_BUTTON_TYPE_URL,
	PHONE: MESSAGE_PREVIEW_BUTTON_TYPE_PHONE,
};
/** @type {MessagePreviewButtonType[]} */
export const MESSAGE_PREVIEW_BUTTON_TYPES = [
	MESSAGE_PREVIEW_BUTTON_TYPE_QUICK_REPLY, 
	MESSAGE_PREVIEW_BUTTON_TYPE_URL, 
	MESSAGE_PREVIEW_BUTTON_TYPE_PHONE,
];